/* Suma rendered+dropped+failed trebuie sa fie egala cu lungimea listei din storage; altfel exista pierdere tacuta. */
(function () {
  'use strict';

  var grid = document.querySelector('[data-favorites-grid]');
  if (!grid || !window.amphrFavorites || !window.amphrSkeleton) return;

  var SECTION = 'amphr-favorite-card';
  var CONCURRENCY = 6;
  var generation = 0;
  // Shared with amphr-favorites-hydrate.js: attribute name section-amphr-favorites.css keys its .favempty{display:none} rule on.
  var EMPTY_HIDDEN_ATTR = 'data-fav-empty-hidden';

  function setEmptyHidden(hide) {
    var page = grid.parentElement;
    if (!page) return;
    if (hide) page.setAttribute(EMPTY_HIDDEN_ATTR, '');
    else page.removeAttribute(EMPTY_HIDDEN_ATTR);
  }

  function announce(text) {
    var region = document.querySelector('[data-fav-announce]');
    if (region) region.textContent = text;
  }

  function updateCount() {
    var el = document.querySelector('[data-fav-page-count]');
    if (!el) return;
    var n = window.amphrFavorites.count();
    el.textContent = n + ' ' + (grid.getAttribute('data-count-label') || '');
    el.hidden = n === 0;
  }

  /* Cardul care dispare poate contine focusul; fara mutare, tastatura sare la
     BODY si scoaterea urmatoare cere Tab de la capat. Vecinul se ia INAINTE de
     removeChild, altfel nodul e deja desprins si n-are frati. */
  function focusAfterRemoval(neighbour) {
    var target = neighbour && neighbour.isConnected
      ? neighbour.querySelector('[data-fav-btn], a[href]')
      : null;
    if (!target) target = document.querySelector('.favempty .atc');
    if (!target) {
      target = document.querySelector('.favpage h1');
      if (target && !target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
    }
    if (target) target.focus();
  }

  function routeRoot() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return root.charAt(root.length - 1) === '/' ? root : root + '/';
  }

  function skeletonCard(handle) {
    var wrap = document.createElement('div');
    wrap.innerHTML = window.amphrSkeleton.productCard(1);
    var el = wrap.firstElementChild;
    el.setAttribute('data-sk-handle', handle);
    return el;
  }

  function retryCard(handle) {
    var el = document.createElement('div');
    el.className = 'card card--failed';
    el.setAttribute('data-sk-handle', handle);
    el.setAttribute('data-bucket', 'failed');
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'favretry';
    btn.textContent = grid.getAttribute('data-retry-label') || 'Retry';
    btn.addEventListener('click', function () { render(); });
    el.appendChild(btn);
    return el;
  }

  /* Un 404 nu dovedeste ca produsul a disparut definitiv — poate fi depublicat
     temporar sau absent din piata curenta. Stergerea tacuta a favoritului era
     ireversibila si nesemnalata, asa ca handle-ul ramane in lista si primeste o
     placa explicita, cu scoaterea lasata pe seama clientei. */
  function unavailableCard(handle) {
    var el = document.createElement('div');
    el.className = 'card card--failed card--unavailable';
    el.setAttribute('data-sk-handle', handle);
    el.setAttribute('data-bucket', 'dropped');
    var text = document.createElement('p');
    text.className = 'favgone__title';
    text.textContent = grid.getAttribute('data-unavailable-label') || 'No longer available';
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'favretry';
    btn.textContent = grid.getAttribute('data-remove-label') || 'Remove';
    btn.addEventListener('click', function () { window.amphrFavorites.remove(handle); });
    el.appendChild(text);
    el.appendChild(btn);
    return el;
  }

  function extractCard(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var section = doc.querySelector('[id^="shopify-section-"]');
    var node = (section || doc.body).querySelector('[data-fav-card]');
    return node || null;
  }

  function fetchCard(handle) {
    var url = routeRoot() + 'products/' + encodeURIComponent(handle) + '?section_id=' + SECTION;
    return fetch(url, { credentials: 'same-origin' })
      .then(function (r) {
        if (r.status === 404 || r.status === 410) return { state: 'dropped', handle: handle };
        if (!r.ok) throw new Error('status ' + r.status);
        return r.text().then(function (html) {
          var node = extractCard(html);
          /* section_id nu intoarce 404 pentru un handle inexistent — randeaza
             cardul cu produsul gol, deci semnalul real e data-handle lipsa. */
          if (!node || node.getAttribute('data-handle') !== handle) {
            return { state: 'dropped', handle: handle };
          }
          return { state: 'rendered', handle: handle, node: node };
        });
      })
      .catch(function () {
        return { state: 'failed', handle: handle };
      });
  }

  /* Coada cu latime fixa: 200 de favorite nu inseamna 200 de cereri deodata. */
  function runQueue(handles, worker) {
    var results = new Array(handles.length);
    var next = 0;
    function step() {
      if (next >= handles.length) return Promise.resolve();
      var i = next++;
      return worker(handles[i]).then(function (res) {
        results[i] = res;
        return step();
      });
    }
    var lanes = [];
    for (var i = 0; i < Math.min(CONCURRENCY, handles.length); i++) lanes.push(step());
    return Promise.all(lanes).then(function () { return results; });
  }

  /* Doar scheletele puse de amphr-favorites-hydrate.js — nu si placile de retry, care poarta acelasi atribut. */
  function alreadyHydrated(handles) {
    var existing = grid.querySelectorAll('[data-sk-handle].card--sk');
    if (existing.length !== handles.length) return false;
    for (var i = 0; i < handles.length; i++) {
      if (existing[i].getAttribute('data-sk-handle') !== handles[i]) return false;
    }
    return true;
  }

  function render() {
    var handles = window.amphrFavorites.list();
    var gen = ++generation;

    if (!handles.length) {
      grid.removeAttribute('data-rendered');
      grid.removeAttribute('data-dropped');
      grid.removeAttribute('data-failed');
      grid.removeAttribute('data-abandoned');
      while (grid.firstChild) grid.removeChild(grid.firstChild);
      grid.setAttribute('aria-busy', 'false');
      grid.setAttribute('data-rendered', '0');
      grid.setAttribute('data-dropped', '0');
      grid.setAttribute('data-failed', '0');
      grid.setAttribute('data-abandoned', '0');
      setEmptyHidden(false);
      updateCount();
      return;
    }

    grid.removeAttribute('data-rendered');
    grid.removeAttribute('data-dropped');
    grid.removeAttribute('data-failed');
    grid.removeAttribute('data-abandoned');
    setEmptyHidden(true);
    grid.setAttribute('aria-busy', 'true');
    if (!alreadyHydrated(handles)) {
      while (grid.firstChild) grid.removeChild(grid.firstChild);
      handles.forEach(function (h) { grid.appendChild(skeletonCard(h)); });
    }

    runQueue(handles, fetchCard).then(function (results) {
      /* O trecere mai veche isi vede coada rezolvata dupa ce a pornit alta
         (ex. eveniment `storage` in timpul hidratarii initiale) — abandoneaza
         fara sa scrie noduri sau galeti, ca sa nu duplice carduri. */
      if (gen !== generation) return;

      /* Citita DUPA ce coada s-a asezat: un handle scos din favorite cat timp
         cererea lui era in zbor nu mai are voie sa ajunga pe ecran. Fara asta,
         `slot` lipseste si ramura `appendChild` de mai jos il readuce ca un card
         fantoma, cu inima goala si necontabilizat de contorul din antet. */
      var live = window.amphrFavorites.list();
      var counts = { rendered: 0, dropped: 0, failed: 0, abandoned: 0 };

      results.forEach(function (res) {
        var slot = grid.querySelector('[data-sk-handle="' + res.handle + '"]');
        if (live.indexOf(res.handle) === -1) {
          counts.abandoned++;
          if (slot) grid.removeChild(slot);
          return;
        }
        counts[res.state]++;
        if (res.state === 'rendered') {
          if (slot) grid.replaceChild(res.node, slot);
          else grid.appendChild(res.node);
        } else if (res.state === 'dropped') {
          if (slot) grid.replaceChild(unavailableCard(res.handle), slot);
          else grid.appendChild(unavailableCard(res.handle));
        } else if (slot) {
          grid.replaceChild(retryCard(res.handle), slot);
        }
      });

      grid.setAttribute('aria-busy', 'false');
      grid.setAttribute('data-rendered', String(counts.rendered));
      grid.setAttribute('data-dropped', String(counts.dropped));
      grid.setAttribute('data-failed', String(counts.failed));
      grid.setAttribute('data-abandoned', String(counts.abandoned));

      if (!grid.querySelector('.card')) setEmptyHidden(false);
      updateCount();
    });
  }

  var initial = true;
  window.amphrFavorites.subscribe(function (items) {
    if (initial) { initial = false; render(); return; }
    /* Re-randarea completa doar cand lista chiar s-a schimbat ca lungime sau
       continut; altfel scoaterea unui card ar reincarca toata pagina.
       `shown` acopera si placile de retry (`[data-sk-handle]`, galeata
       `failed`), nu doar cardurile randate — altfel un handle esuat scos din
       storage din alt tab nu era recunoscut ca „disparut" si placa lui ramanea
       pe ecran la nesfarsit. */
    var shownRendered = Array.prototype.map.call(
      grid.querySelectorAll('[data-fav-card]'),
      function (n) { return n.getAttribute('data-handle'); }
    );
    var shownFailed = Array.prototype.map.call(
      grid.querySelectorAll('[data-sk-handle]'),
      function (n) { return n.getAttribute('data-sk-handle'); }
    );
    var shown = shownRendered.concat(shownFailed);
    var removed = shown.filter(function (h) { return items.indexOf(h) === -1; });
    if (removed.length) {
      /* In timpul unei treceri galetile sunt scoase dinadins, iar trecerea si le
         scrie singura la final; scaderea de aici ar inventa cifre peste ele. */
      var busy = grid.getAttribute('aria-busy') === 'true';
      var hadFocus = false;
      var focusNeighbour = null;
      var removedTitles = [];
      removed.forEach(function (h) {
        var node = grid.querySelector('[data-fav-card][data-handle="' + h + '"]') ||
                   grid.querySelector('[data-sk-handle="' + h + '"]');
        if (!node) return;
        if (node.contains(document.activeElement)) {
          hadFocus = true;
          focusNeighbour = node.nextElementSibling || node.previousElementSibling;
        }
        var title = node.querySelector('h4');
        if (title) removedTitles.push(title.textContent.trim());
        /* Placa de retry si cea de indisponibil poarta acelasi `data-sk-handle`,
           dar stau in galeti diferite; `data-bucket` spune care. */
        var bucket = node.getAttribute('data-bucket') || 'rendered';
        grid.removeChild(node);
        if (busy) return;
        var key = 'data-' + bucket;
        grid.setAttribute(key, String(Math.max(0, Number(grid.getAttribute(key) || '0') - 1)));
      });
      if (!grid.querySelector('.card')) setEmptyHidden(false);
      updateCount();
      if (removedTitles.length) {
        announce((grid.getAttribute('data-removed-label') || '') + ': ' + removedTitles.join(', '));
      }
      if (hadFocus) focusAfterRemoval(focusNeighbour);
      return;
    }
    var added = items.filter(function (h) { return shown.indexOf(h) === -1; });
    if (added.length) render();
  });
})();
